module.exports = __webpack_public_path__ + "static/media/light-divider.d83f38df.png";